import { useLocalizedText } from '../../hooks/localizedText';

export function AmbassadorDirectoryDosAndDonts() {
  const { t } = useLocalizedText(['ambassadors', 'translation']);

  return (
    <>
      <h3>{t('ambassadorDirectory.do')}</h3>
      <p data-ambassador-directory-do>{t('ambassadorDirectory.checkYourRegistration')}</p>
      <p data-ambassador-directory-do>{t('ambassadorDirectory.reachOutToNearby')}</p>
      <p data-ambassador-directory-do>{t('ambassadorDirectory.seeIfThereAre')}</p>
      <h3>{t('ambassadorDirectory.dont')}</h3>
      <p data-ambassador-directory-dont>{t('ambassadorDirectory.exportForThePurpose')}</p>
      <p data-ambassador-directory-dont>{t('ambassadorDirectory.bulkEmailAmbassadors')}</p>
    </>
  );
}
